import { render } from "./ClientUpdateOrder.vue?vue&type=template&id=6d42be8e&scoped=true"
import script from "./ClientUpdateOrder.vue?vue&type=script&lang=js"
export * from "./ClientUpdateOrder.vue?vue&type=script&lang=js"

import "./ClientUpdateOrder.vue?vue&type=style&index=0&id=6d42be8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d42be8e"]])

export default __exports__